import { ReactNode } from "react";
import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import styles from "./AssetToggleOrStatus.module.css";

interface ToggleContainerProps {
  tooltipContent: string;
  children: ReactNode;
  ariaLabel?: string;
}

export function ToggleContainer({
  tooltipContent,
  children,
  ariaLabel = "Asset status",
}: ToggleContainerProps) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <div
      className={styles.container}
      role="status"
      data-testid="asset-indicator"
      aria-label={ariaLabel}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
      onContextMenu={(e) => e.stopPropagation()}
    >
      <Tooltip allowMultiline content={tooltipContent} placement="bottom">
        <TooltipFocusableTrigger>{children}</TooltipFocusableTrigger>
      </Tooltip>
    </div>
  );
}
